var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('bread-crumbs',{attrs:{"items":_vm.breadCrumbs}}),_c('v-card',{staticClass:"pt-8 mt-3"},[_c('h4',{staticClass:"container-title"},[_vm._v("لیست رک "+_vm._s(_vm.titleExcel)+" ")]),_c('v-card-text',{staticClass:"pa-5"},[(_vm.rackListData)?_c('v-sheet',{staticClass:"mt-5",attrs:{"elevation":"4"}},[_c('p',{staticClass:"pa-5"},[_c('span',[_vm._v(" نام مشتری:")]),_c('span',[_vm._v(_vm._s(_vm.customerName))])]),_c('v-data-table',{staticClass:"elevation-3",attrs:{"id":"exportTable","headers":_vm.headers,"items":_vm.rackListData,"items-per-page":10,"footer-props":{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-plus',
        nextIcon: 'mdi-minus',
        itemsPerPageOptions:[10,15]
      }}})],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }